// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ql--7","badges":"styles_badges__1oMIy"};